import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditDeviceModal = ({ show, handleClose, device, onChange, onSave }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Device</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formDeviceName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={device.name}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceType">
            <Form.Label>Type</Form.Label>
            <Form.Control
              type="text"
              name="type"
              value={device.type}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceHostname">
            <Form.Label>Hostname</Form.Label>
            <Form.Control
              type="text"
              name="hostname"
              value={device.hostname}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceLanIP">
            <Form.Label>LAN IP</Form.Label>
            <Form.Control
              type="text"
              name="lanIP"
              value={device.lanIP}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceLocation">
            <Form.Label>Location</Form.Label>
            <Form.Control
              type="text"
              name="location"
              value={device.location}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceVendor">
            <Form.Label>Vendor</Form.Label>
            <Form.Control
              type="text"
              name="vendor"
              value={device.vendor}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group controlId="formDeviceSupportNumber">
            <Form.Label>Support Number</Form.Label>
            <Form.Control
              type="text"
              name="supportNumber"
              value={device.supportNumber}
              onChange={onChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDeviceModal;